import { useEffect, useRef } from "react";
import { http } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const { setUser } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const sessionId = new URLSearchParams(window.location.hash.replace("#", "")).get("session_id");
    (async () => {
      try {
        const { data } = await http.post("/auth/session", { session_id: sessionId });
        setUser(data);
        window.history.replaceState(null, "", "/admin");
        window.location.replace("/admin");
      } catch {
        window.location.replace("/login");
      }
    })();
  }, [setUser]);

  return <div className="min-h-screen bg-[#0A0A0A]" />;
}
